import { PropSelectOptions } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import * as User from "redux-store/users/selectors";
import { BackButton } from "ui/button/back";
import { NavLoader } from "ui/loader";
import { Notification } from "ui/notification";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";
import { VIEW } from "view/views";

import { UserDetailForm } from "./detail-form";

class UserDetailPage extends React.PureComponent {
  static get propTypes() {
    return {
      editUser: PropTypes.func.isRequired,
      inviteUser: PropTypes.func.isRequired,
      networkOptions: PropSelectOptions,
      storesLoaded: PropTypes.bool.isRequired,
      type: PropTypes.oneOf([VIEW.CREATE, VIEW.EDIT]).isRequired,
      user: PropTypes.object,
      currentUser: PropTypes.object,
      featureFlags: PropTypes.object,
    };
  }

  static get defaultProps() {
    return {
      user: {},
      currentUser: {},
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      successMessage: "",
    };

    this._doSubmit = this._doSubmit.bind(this);
    this.setRef = this.setRef.bind(this);
    this.submit = this.submit.bind(this);

    this.form = null;
  }

  _doSubmit() {
    const { editUser, inviteUser, user } = this.props;
    const { id } = user;

    const formValues = this.form.getFormValues();
    const { email, name, networks } = formValues;
    const networkIds = networks ? this._serializeNetworks(networks) : null;
    const role = formValues.role ? formValues.role.value : null;

    const serviceArgs = {
      email,
      id,
      name,
      networkIds,
      role,
    };

    const isEditView = this._isEditView();
    const submitHandler = isEditView ? editUser : inviteUser;
    const action = isEditView ? "edited" : "invited";

    return submitHandler(serviceArgs)
      .then(() => {
        this.setState({
          successMessage: `User ${action} successfully.`,
        });
      })
      .finally(() => {
        this.setState({ submitted: false });
      });
  }

  _getPageTitle() {
    const isEditView = this._isEditView();
    const { user } = this.props;

    return isEditView ? `Edit User ${user.name || ""}` : "Invite User";
  }

  _isEditView() {
    return this.props.type === VIEW.EDIT;
  }

  _serializeNetworks(networkOptions) {
    return networkOptions ? networkOptions.map((o) => o.value) : null;
  }

  setRef(el) {
    if (el) {
      this.form = el;
    }
  }

  submit() {
    this.setState(
      {
        submitted: true,
        successMessage: "",
      },
      this._doSubmit,
    );
  }

  _renderView() {
    const { submitted, successMessage } = this.state;
    const { networkOptions, type, user, currentUser, featureFlags } = this.props;
    const { storesLoaded } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    const isEditView = this._isEditView();
    if (isEditView && !user.id) {
      return <Redirect to="/404" />;
    }

    const UserListLink = <Link to="/users">User List</Link>;

    return (
      <Row>
        <Col xs={6}>
          <Notification
            success={successMessage}
            successChildren={UserListLink}
          />

          <UserDetailForm
            key={user.id || 0}
            networkOptions={networkOptions}
            ref={this.setRef}
            submitted={submitted}
            type={type}
            user={user}
            currentUser={currentUser}
            featureFlags={featureFlags}
          />

          <Row>
            <Col xs={12}>
              <BackButton />
              <Button
                variant="primary"
                onClick={this.submit}
                disabled={submitted}
              >
                {isEditView ? "Update" : "Invite"}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  render() {
    const { currentUser } = this.props;

    if (!User.isFullAdmin(currentUser)) {
      return <Redirect to="/404" />;
    }

    return (
      <Page title={this._getPageTitle()}>
        <Box noHeader>{this._renderView()}</Box>
      </Page>
    );
  }
}

export { UserDetailPage };
